	<div style="height: calc(100% - 100px); position: relative; padding: 2rem;">
		<div class="header">
			<button mat-raised-button color="secondary" (click)="backClicked()">Back</button>
			<div class="title">
				<h3>Date: {{inputDate}} Stage: {{stage}} Risk: {{risk}}</h3>
			</div>
			<div style="display: flex;">
				<mat-form-field class="table-filter" appearance="outline" style="margin-right: 15px;">
					<mat-label>Global Filter</mat-label>
					<input matInput type="text" [(ngModel)]="filterValue" (input)="onFilterTextBoxChanged()"
						placeholder="Start typing to filter table..." />
					<mat-icon *ngIf="!filterValue" matSuffix>filter_list</mat-icon>
					<button *ngIf="filterValue" matSuffix mat-icon-button aria-label="Clear" (click)="onFilterClear()">
						<mat-icon>close</mat-icon>
					</button>
				</mat-form-field>
				<button mat-raised-button color="primary" (click)="resetFilter()" style="height: 55px;">
					Reset Filters
				</button>
			</div>
		</div>
		<ag-grid-angular style="width: 100%; height: 100%; font-size: 15px;" class="ag-theme-material"
			[columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [rowData]="rowData" [rowSelection]="'multiple'"
			[rowHeight]="20" [animateRows]="true" [pagination]="true" [paginationPageSize]="50"
			[cacheQuickFilter]="true" [enableCellTextSelection]="true" [tooltipShowDelay]="tooltipShowDelay"
			[tooltipHideDelay]="tooltipHideDelay" [sideBar]="sideBar" [overlayLoadingTemplate]="overlayLoadingTemplate"
			(gridReady)="onGridReady($event)"></ag-grid-angular>
	</div>